import React, { useEffect, useState } from "react";

const Blogs = () => {
    const [selectedIndustry, setSelectedIndustry] = useState("All");
    const [selectedService, setSelectedService] = useState("All");
    const [searchQuery, setSearchQuery] = useState("");

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const industries = [
        "All",
        "Healthcare",
        "Finance",
        "E-commerce",
        "Education",
        "Manufacturing",
        "Retail"
    ];

    const services = [
        "All",
        "AI & ML",
        "Mobile App",
        "Web Development",
        "Cloud Services",
        "Blockchain",
        "DevOps"
    ];

    const blogPosts = [
        {
            id: 1,
            title: "How to Create an Intranet Site Using SharePoint for Your Business",
            image: "https://www.q3tech.com/wp-content/uploads/2025/11/Intranet-Site-Using-SharePoint.jpg",
            category: "SHAREPOINT",
            date: "Dec 15, 2024",
            industry: "All",
            service: "Web Development",
            excerpt: "Learn how to leverage SharePoint to build a powerful intranet solution that enhances collaboration and productivity in your organization."
        },
        {
            id: 2,
            title: "AI Agent Use Cases: Real-World Applications Revolutionizing Business Operations",
            image: "https://www.q3tech.com/wp-content/uploads/2025/11/AI-Agent-Use-Cases.jpg",
            category: "AI AGENT",
            date: "Dec 10, 2024",
            industry: "All",
            service: "AI & ML",
            excerpt: "Discover how AI agents are transforming business operations across industries with real-world applications and use cases."
        },
        {
            id: 3,
            title: "SharePoint Corporate Intranet Portal Features for Modern Enterprises",
            image: "https://www.q3tech.com/wp-content/uploads/2025/11/SharePoint-Corporate-Intranet-Portal.jpg",
            category: "SHAREPOINT",
            date: "Dec 5, 2024",
            industry: "Finance",
            service: "Cloud Services",
            excerpt: "Explore the essential features of SharePoint corporate intranet portals that drive digital transformation in modern enterprises."
        },
        {
            id: 4,
            title: "Machine Learning in Healthcare: Transforming Patient Care",
            image: "https://www.q3tech.com/wp-content/uploads/2025/11/Risk-Management-Software-Companies.jpg",
            category: "AI & ML",
            date: "Nov 28, 2024",
            industry: "Healthcare",
            service: "AI & ML",
            excerpt: "Understand how machine learning algorithms are revolutionizing healthcare delivery and improving patient outcomes."
        },
        {
            id: 5,
            title: "Building Scalable Mobile Apps with React Native",
            image: "https://www.q3tech.com/wp-content/uploads/2025/11/ERP-AI-Chatbots.jpg",
            category: "MOBILE DEV",
            date: "Nov 20, 2024",
            industry: "E-commerce",
            service: "Mobile App",
            excerpt: "Best practices and strategies for building high-performance, scalable mobile applications using React Native."
        },
        {
            id: 6,
            title: "Blockchain Technology in Supply Chain Management",
            image: "https://www.q3tech.com/wp-content/uploads/2025/11/IT-for-Education-Sector.jpg",
            category: "BLOCKCHAIN",
            date: "Nov 15, 2024",
            industry: "Manufacturing",
            service: "Blockchain",
            excerpt: "How blockchain is creating transparency and efficiency in modern supply chain operations."
        }
    ];

    const filteredBlogs = blogPosts.filter(blog => {
        const matchesIndustry = selectedIndustry === "All" || blog.industry === selectedIndustry;
        const matchesService = selectedService === "All" || blog.service === selectedService;
        const matchesSearch = blog.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
            blog.excerpt.toLowerCase().includes(searchQuery.toLowerCase());

        return matchesIndustry && matchesService && matchesSearch;
    });

    return (
        <div className="blogs-page">
            {/* Hero Section */}
            <section className="blogs-hero-section padding-left-right py-5">
                <div className="container-fluid">
                    <div className="row align-items-center" style={{ minHeight: "50vh" }}>
                        <div className="col-12 text-center">
                            <p className="text-uppercase mb-3" style={{
                                color: "#4187f7",
                                fontSize: "0.9rem",
                                fontWeight: "600",
                                letterSpacing: "2px"
                            }}>
                                LATEST INSIGHTS
                            </p>
                            <h1 className="display-3 fw-bold text-white mb-4">
                                Blogs
                            </h1>
                            <p className="lead text-white-50 mx-auto" style={{ maxWidth: "700px" }}>
                                Stay updated with the latest trends, insights, and innovations in technology,
                                AI, development, and digital transformation.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Filters Section */}
            <section className="blogs-filters-section padding-left-right py-5" style={{
                background: "#0f0f10"
            }}>
                <div className="container-fluid">
                    <div className="row">
                        {/* Industries Filter */}
                        <div className="col-lg-4">
                            <label className="text-white mb-2 fw-semibold">Industries</label>
                            <select
                                className="form-select"
                                value={selectedIndustry}
                                onChange={(e) => setSelectedIndustry(e.target.value)}
                                style={{
                                    background: "#1a1a1c",
                                    border: "1px solid rgba(255,255,255,0.1)",
                                    color: "#fff",
                                    padding: "12px 16px",
                                    borderRadius: "8px"
                                }}
                            >
                                {industries.map(industry => (
                                    <option key={industry} value={industry}>{industry}</option>
                                ))}
                            </select>
                        </div>

                        {/* Services Filter */}
                        <div className="col-lg-4">
                            <label className="text-white mb-2 fw-semibold">Services</label>
                            <select
                                className="form-select"
                                value={selectedService}
                                onChange={(e) => setSelectedService(e.target.value)}
                                style={{
                                    background: "#1a1a1c",
                                    border: "1px solid rgba(255,255,255,0.1)",
                                    color: "#fff",
                                    padding: "12px 16px",
                                    borderRadius: "8px"
                                }}
                            >
                                {services.map(service => (
                                    <option key={service} value={service}>{service}</option>
                                ))}
                            </select>
                        </div>

                        {/* Search */}
                        <div className="col-lg-4">
                            <label className="text-white mb-2 fw-semibold">Search</label>
                            <div style={{ position: "relative" }}>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search blogs..."
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    style={{
                                        background: "#1a1a1c",
                                        border: "1px solid rgba(255,255,255,0.1)",
                                        color: "#fff",
                                        padding: "12px 45px 12px 16px",
                                        borderRadius: "8px"
                                    }}
                                />
                                <svg
                                    style={{
                                        position: "absolute",
                                        right: "16px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        width: "20px",
                                        height: "20px",
                                        fill: "#888"
                                    }}
                                    viewBox="0 0 24 24"
                                >
                                    <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Blog Cards Section */}
            <section className="blogs-content-section padding-left-right py-5" style={{
                background: "#0f0f10"
            }}>
                <div className="container-fluid">
                    {filteredBlogs.length === 0 ? (
                        <div className="text-center py-5">
                            <p className="text-white-50 fs-5">No blogs found matching your criteria.</p>
                        </div>
                    ) : (
                        <div className="row">
                            {filteredBlogs.map((blog) => (
                                <div key={blog.id} className="col-lg-4 col-md-6">
                                    <article className="blog-card h-100">
                                        <div className="blog-image-wrapper">
                                            <img
                                                src={blog.image}
                                                alt={blog.title}
                                                className="blog-image"
                                            />
                                            <span className="blog-category-badge">{blog.category}</span>
                                        </div>
                                        <div className="blog-content">
                                            <p className="blog-date">{blog.date}</p>
                                            <h3 className="blog-title">{blog.title}</h3>
                                            <p className="blog-excerpt">{blog.excerpt}</p>
                                            <a href={`#blog-${blog.id}`} className="blog-read-more">
                                                Read More
                                                <svg
                                                    width="16"
                                                    height="16"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2"
                                                    style={{ marginLeft: "8px" }}
                                                >
                                                    <path d="M5 12h14M12 5l7 7-7 7" />
                                                </svg>
                                            </a>
                                        </div>
                                    </article>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
};

export default Blogs;
